import React from "react";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import { CustomTooltip } from "../../consts.js";
import { useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import SettingHeader from "./setting-header.jsx";
import CreateCompanyComponent from "./create-company.jsx";
import { Grid, IconButton } from "@mui/material";
import TableComponent from "../../components/table/list.jsx";
import { ADMIN_GROUP_NAME } from "../../helpers/constant.js";
import { getCompanyListAPI } from "../../services/settings.js";
import { AuthContext } from "../../components/auth/AuthContext.js";

function Admin() {
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [newCampDiag, setNewCampDiag] = React.useState(false);
    const [selectedTab] = React.useState("Companies");
    const [spinner, setSpinner] = React.useState(false);
    const { isAuthenticated, isAdmin } = React.useContext(AuthContext);
    const [pageInfo, setPageInfo] = React.useState({
        currentPage: 0,
        rowsPerPage: 10,
        nextPage: null,
    });
    const [totalRecords, setTotalRecords] = React.useState(0);

    async function getData(rowsPerPage = pageInfo.rowsPerPage, nextPage = pageInfo.nextPage) {
        try {
            setSpinner(true);
            const _data = await getCompanyListAPI({
                limit: rowsPerPage,
                lastKey: nextPage,
                includeUserCount: true,
            });
            let newData = [..._data.items];
            if (nextPage) {
                newData = [...data, ..._data.items];
            }
            setData([...newData]);
            setTotalRecords(_data.totalRecords);
            setPageInfo((prev) => ({ ...prev, nextPage: _data.lastKey || null }));
            setSpinner(false); // Update the state with all items
        } catch (error) {
            console.error("Error fetching campaign _data: ", error);
            setSpinner(false);
        }
    }

    React.useEffect(() => {
        if (isAdmin) {
            getData();
        } else {
            return navigate("/", {
                replace: true,
            });
        }
        window.scrollTo(0, 0); // Scroll to top when component mounts
    }, [isAuthenticated, isAdmin]);

    // define table headers
    const columns = React.useMemo(() => ([
        {
            label: "Company Name",
            key: "name",
            sortable: true,
            renderItem: (row) => row.name || "-",
        },
        {
            label: "Contact Name",
            key: "contact",
            sortable: true,
            renderItem: (row) => row.contact || "-",
        },
        {
            label: "Email",
            key: "email",
            sortable: true,
            renderItem: (row) => row.email || "-",
        },
        {
            label: "Status",
            key: "status",
            sortable: false,
            renderItem: (row) => (<Chip
                label={row.status === "active" ? "Active" : "Inactive"}
                color={row.status === "active" ? "success" : "info"}
            />)
        },
        {
            label: "# Users",
            key: "userCount",
            sortable: true,
            renderItem: (row) => row.userCount || "-",
        },
        // {
        //     label: "Usage",
        //     key: "usage",
        //     sortable: false,
        //     renderItem: (row) => row.usage || "-",
        // },
        {
            label: "Edit",
            key: 'edit',
            sortable: false,
            renderItem: (row) => (row.email !== ADMIN_GROUP_NAME && <CustomTooltip title={"Edit"}>
                <IconButton
                    aria-label="Edit"
                    size="small"
                    color="inherit"
                    onClick={() =>
                        navigate("/edit-company?id=" + row.id)
                    }
                >
                    <FeatherIcon icon="edit-2" size={20} />
                </IconButton>
            </CustomTooltip>)
        }
    ]), [data]);

    const headerActionButtons = () => {
        return (
            <Button
                variant="contained"
                onClick={() => setNewCampDiag(true)}
                startIcon={<FeatherIcon icon="plus-circle" size={20} />}
            >
                Create Company
            </Button>
        )
    }

    const handlePageChange = (_pageInfo) => {
        let nextPage = pageInfo.nextPage;
        if (_pageInfo.REFRESH_DATA) {
            nextPage = null
        }
        setPageInfo({
            ...pageInfo,
            nextPage,
            currentPage: _pageInfo.currentPage,
            rowsPerPage: _pageInfo.rowsPerPage
        });
        if (nextPage || _pageInfo.REFRESH_DATA) {
            getData(_pageInfo.rowsPerPage, nextPage);
        }
    }

    return (
        <Grid display="flex" flexDirection="column" flexGrow="1" overflow="auto">
            <SettingHeader title={"Companies"} selectedTab={selectedTab} />
            <Grid
                className="vocalysed-home-upadted admin-user"
                container
                spacing={0}
                direction="column"
                flexWrap="nowrap"
                flexGrow={1}
                paddingTop={2}
                paddingX={3}
                paddingBottom={3}
                overflow="auto"
            >
                <TableComponent
                    headerActionButtons={headerActionButtons}
                    spinner={spinner}
                    data={data}
                    columns={columns}
                    pagination={true}
                    serverPaginate={true}
                    currentPage={pageInfo.currentPage}
                    hasNextPage={pageInfo.nextPage !== null}
                    totalCount={totalRecords}
                    searchKeys={["name", "email", "contact"]}
                    noDataMessage={"No companies found."}
                    onPageChange={handlePageChange}
                />
            </Grid>

            {/* Create Company Modal */}
            <CreateCompanyComponent
                open={newCampDiag}
                onClose={async (inp) => {
                    if (inp === null) setNewCampDiag(false);
                    else {
                        handlePageChange({ REFRESH_DATA: true, currentPage: 0, rowsPerPage: pageInfo.rowsPerPage });
                        setNewCampDiag(false);
                    }
                }}
            />
        </Grid>
    );
}

export default Admin;
